






























import { defineComponent, ref } from '@vue/composition-api';
import { SpecificPropsType } from '@/components/form/types';
import { ConfTable } from '@/components/table/table';
import { ConfTableProps } from '@/components/table/types';
import { getMPAppList } from '@api/plc';
import { detailColumns } from '../plc/detail-columns';
import ApplyPlc from './apply.vue';

export default defineComponent({
    components: {
        ConfTable,
        ApplyPlc,
    },
    props: ['scopeGroupId'] as unknown as SpecificPropsType<{
        scopeGroupId: number;
    }>,
    setup(props, { root }) {
        const visible = ref(false);
        const tableRef = ref<InstanceType<typeof ConfTable>>();

        const api: ConfTableProps['api'] = async (query) => {
            const res = await getMPAppList(root.$route.params.appId);
            return res.data.data.mpAppList || [];
        };

        return {
            visible,
            tableRef,
            api,
            columns: detailColumns(props.scopeGroupId),
            fetch() {
                tableRef.value?.fetch();
            },
        };
    },
});
